
const URL =
  "wss://9b29y7ye8g.execute-api.ap-south-1.amazonaws.com/production/?";

export const ws = new WebSocket(URL);
